const categories = [
  { "id": 1, "name": "Regulatory Compliance Workflow"},
  { "id": 2, "name": "Internal Compliance Workflow"},
  { "id": 3, "name": "Customer Protection Rate" },
]
export default categories;

export const getCategoryByItem = (item) => categories.find(c => c.id === item.category);